module.exports = __webpack_public_path__ + "static-portal/img/map-pta.29f8535.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/map-pta.png
// module id = B7GB
// module chunks = 4